import { useRecordContext, useTranslate } from "react-admin";

import { LocationModeEnum, LocationTypeEnum } from "../generated/graphql";
import { InfoFieldData, InfoPanel } from "./InfoPanel";

export type LocationRecord = {
  id: string;
  name?: string;
  externalId?: string;
  type?: LocationTypeEnum | null;
  mode?: LocationModeEnum;
  status?: string;
  partOfId?: string;
  organization?: {
    id: string;
    name?: string;
  };
};

export const LocationInfoPanel = () => {
  const record = useRecordContext<LocationRecord>();
  const translate = useTranslate();

  if (!record) return null;

  const sections: InfoFieldData[][] = [
    [
      { label: translate("locationName"), value: record.name },
      {
        label: translate("type"),
        value: record.type ? translate(`locationType.${record.type}`) : undefined,
      },
      {
        label: translate("mode"),
        value: record.mode ? translate(`locationMode.${record.mode}`) : undefined,
      },
    ],
    [
      { label: translate("externalId"), value: record.externalId },
      { label: translate("internalId"), value: record.id },
    ],
    [{ label: translate("organization"), value: record.organization?.name }],
  ];

  return <InfoPanel sections={sections} />;
};
